import { TextField } from "@mui/material";
import { width } from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

export default function CounterRecords(props) {
    const { t } = useTranslation();

    const { value } = props;

    const getLabel = () => {
        const label = props.label ? props.label : t("number_of_records");
        return label.charAt(0).toUpperCase() + label.slice(1);
    };

    return (
        <TextField
            id="counterRecord"
            disabled
            label={getLabel()}
            size="small"
            value={Number.parseInt(value)}
        />
    );
}

CounterRecords.propTypes = {
    value: PropTypes.number,
    label: PropTypes.string,
};
